import React from 'react';
import { Box, Heading, Text, Center } from '@chakra-ui/react';

import BgBorder from '@/assets/border/wedding.png';
import ImgDivider from '@/assets/border/divider.png';

import ViewLocationButton from '@components/Common/Buttons/ViewLocation';
import WithAnimation from '@components/Common/WithAnimation';
import Image from '@/components/Common/LazyImage';

import useShiftTime from '@/hooks/useShiftTime';
import useInvitation from '@/hooks/useInvitation';

import {
  WEDDING_RESEPSI_DAY,
  WEDDING_AKAD_TIME,
  WEDDING_RESEPSI,
  WEDDING_DATE_DATE,
  WEDDING_LOCATION_ROAD,
  WEDDING_LOCATION,
} from '@/constants';
import {DEFAULT_LANGUAGE as lang} from '@/constants/feature-flags';

import txtWording from './locales';

/**
 * function to render WeddingSectionV3 component
 * @returns {JSX.Element}
 */
function WeddingSection({...rest}) {
  const time = useShiftTime();
  const isInvitation = useInvitation();

  return (
    <Box bgColor="mainColor" padding="32px" >
      <Box
      {...rest}
        marginTop="42px"
        padding="42px 16px"
        bgRepeat="no-repeat"
        width="100%"
        bgSize="100% 100%"
        bgImage={`url(${BgBorder})`}
      >
        <Box>
          <WithAnimation>
            <Heading
              textAlign="center"
              fontFamily="cursive"
              color="secondaryColorText"
              fontWeight="normal"
              fontSize="4xl"
            >
              {txtWording.title[lang]}
            </Heading>
          </WithAnimation>
          {/* Box Akad Information */}
          {false &&<WithAnimation>
            <Box
              textAlign="center"
              color="secondaryColorText"
              fontFamily="serif"
              textTransform="uppercase"
              fontSize="sm"
            >
              <Text fontWeight="bold" m="16px 0" fontSize="md">
                {txtWording.akad[lang]}
              </Text>
              <Text m="16px 0">
                {txtWording.subtitleAkad[lang]}
              </Text>
              <Text fontWeight="bold">{`${WEDDING_RESEPSI_DAY}, ${WEDDING_DATE_DATE}`}</Text>
              <Text fontWeight="bold">{WEDDING_AKAD_TIME}</Text>
            </Box>
          </WithAnimation>}
          {/* DIVIDER section */}
          {isInvitation && false && (
            <WithAnimation>
              <Center>
                <Image src={ImgDivider} maxWidth="100%" margin="24px 0" />
              </Center>
            </WithAnimation>
          )}
          {/* Box Reception Information */}
         
            <WithAnimation>
              <Box
                textAlign="center"
                color="secondaryColorText"
                fontFamily="serif"
                textTransform="uppercase"
                fontSize="sm"
              >
                <Text fontWeight="bold" m="16px 0" marginTop="12px" fontSize="md">
                  {txtWording.reception[lang]}
                </Text>
                {isInvitation &&<Text marginBottom="16px">
                  {txtWording.subtitleReception[lang]}
                </Text>}
                <Text fontWeight="bold">{`${WEDDING_RESEPSI_DAY}, ${WEDDING_RESEPSI}`}</Text>
                <Text fontWeight="bold">{time}</Text>
                {isInvitation &&<>
                <br />
                <Text fontWeight='bold' dangerouslySetInnerHTML={{ __html: WEDDING_LOCATION }} />
                <Text fontSize='xs'>
                  {WEDDING_LOCATION_ROAD}
                </Text>
                </>}
              </Box>
            </WithAnimation>
          
          {/* BOX Button View Location */}
          {isInvitation && (
            <WithAnimation>
              <Center>
                <ViewLocationButton
                  marginTop="16px"
                  size="sm"
                  fontWeight="light"
                  color="mainColor"
                  bgColor="bgPrimary"
                  text={txtWording.maps[lang]}
                />
              </Center>
            </WithAnimation>
          )}
        </Box>
      </Box>
    </Box>
  );
}

export default React.memo(WeddingSection);
